import { Box, Button, FormControl, FormControlLabel, Grid, Grid2, IconButton, MenuItem, Paper, Radio, RadioGroup, Select, Snackbar, Table, TableBody, TableCell, TableContainer, TableHead, TableRow, TableSortLabel, TextField, Typography } from "@mui/material";
import TokenError from '../tokenError';
import {
    makeGetRequestToUrl,
    makePostRequestToUrl,
    importCSV,
    parseCSVLine,
    handleImportCSVWithCaseInsensitive,
    processBulkImport
} from '../commonFunc.jsx';
import config from '../../config/config.js';
import { useNavigate } from "react-router-dom";
import prevIcon from '../../assets/icons/left-arrow.svg';
import nextIcon from '../../assets/icons/right-arrow.svg';
import CloseIcon from '@mui/icons-material/Close';
import React, { useState, useEffect, useRef } from 'react';
import { Label } from "flowbite-react";
import dayjs, { utc } from "dayjs";
import { DatePicker, LocalizationProvider } from "@mui/x-date-pickers";
import { DemoContainer } from '@mui/x-date-pickers/internals/demo';
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import timezone from 'dayjs/plugin/timezone';
import customParseFormat from "dayjs/plugin/customParseFormat";
import exportCSVIcon from '../../assets/icons/exportCsvBlack.svg';
import importArrowIcon from '../../assets/images/importArrow.svg';
import { CSVLink } from "react-csv";

var constants = require('../../constant.js');
dayjs.extend(customParseFormat);
dayjs.extend(utc);

const TruckHead = () => {
    const serverUrl = config.serverUrl;
    const operationsUrl = config.operationsUrl;
    const navigate = useNavigate();
    const cities = JSON.parse(localStorage.getItem('cities'));

    const [cityFilter, setCityFilter] = useState(cities[0].city_id);
    const [tokenExpired, setTokenExpired] = useState(false);
    const [rows, setRows] = useState([]);
    const [order, setOrder] = useState('desc');
    const [orderBy, setOrderBy] = useState('truck_head_id');
    const [page, setPage] = useState(0);
    const [rowsPerPage] = useState(10);
    const [errorMessage, setErrorMessage] = useState('');
    const [snackbar, showSnackbar] = useState(false);
    const [message, setMessage] = useState('');
    const [showTemplateButton, setShowTemplateButton] = useState(false);
    const [allData, setAllData] = useState([]);
    const fileInputRef = useRef(null);
    const [formErrors, setFormErrors] = useState({
        plateNo: false,
        type: false,
        truckerId: false,
        availabilityStatus: false,
        remarks: false
    });
    const [editable, setEditable] = useState(false);
    const [open, setOpen] = useState(false);

    const [plateNo, setPlateNo] = useState('');
    const [type, setType] = useState('');
    const [availabilityStatus, setAvailabilityStatus] = useState('');
    const [remarks, setRemarks] = useState('');
    // const [availabilityTime, setAvailabilityTime] = useState(dayjs());
    const [truckHeadId, setTruckHeadId] = useState('');
    const [truckerId, setTruckerId] = useState('');
    const [truckVendorData, setTruckVendorData] = useState([]);
    
    // CSV import/export functions are implemented below

    const handleRequestSort = (property) => {
        const isAscending = orderBy === property && order === 'asc';
        setOrder(isAscending ? 'desc' : 'asc');
        setOrderBy(property);
        const sortedRows = [...rows].sort((a, b) => {
            if (a[property] < b[property]) return isAscending ? -1 : 1;
            if (a[property] > b[property]) return isAscending ? 1 : -1;
            return 0;
        });
        setRows(sortedRows);
    };

    const handleChangePage = (event, newPage) => {
        setPage(newPage);
    };

    const handleCityChange = (e) =>{
        const city =  cities.find((cityObj) => cityObj.city_id === e)
        setCityFilter(e);
    }
    const handleClose = () => {
        setOpen(false);
        setEditable(false);
    }

    const handleOpenAddTruckHead = () => {
        setOpen(true);
        setEditable(false);
        setPlateNo('');
        setTruckHeadId('');
        setType('');
        setAvailabilityStatus('');
        setRemarks('');
        setTruckerId('');
        // setAvailabilityTime(dayjs());
        setFormErrors({
            plateNo: false,
            type: false,
            truckerId: false,
            availabilityStatus: false,
            remarks: false
        });
    }
    const fetchVendorsData = async() => {
        try {
            const token = localStorage.getItem('token');
            const url = serverUrl + '/transport/fetch_truck_vendors';
            const timestamp = new Date().getTime();
            const body = {
                token: token,
                city_id: cityFilter,
                timestamp: timestamp
            };
            const response =  await makeGetRequestToUrl(url, body);
            if(response.flag==200){
                setTruckVendorData(response.data);
                // const formattedData = formatDataForCSV(response.data);
                // setAllData(formattedData);
            }
            if(response.flag==102){
                console.log('Token is expired. Please login again')
                localStorage.removeItem('token');
                setErrorMessage('Your session has expired. Please log in again.');
                setTokenExpired(true);

                setTimeout(() => {
                    navigate('/signup');
                }, 2000);
                // navigate('/signup');
            }
        }
        catch (error) {
            console.log('error', error);
        }
    }

    const fetchTruckHeadData = async() => {
        try {
            const token = localStorage.getItem('token');
            const url = serverUrl + '/transport/fetch_truck_heads';
            const timestamp = new Date().getTime();
            const body = {
                token: token,
                city_id: cityFilter,
                timestamp: timestamp
            };
            const response = await makeGetRequestToUrl(url, body);
            
            if(response.flag === 401 || response.flag === 102) {
                setTokenExpired(true);
                setMessage('Your session has expired. Please log in again.');
                showSnackbar(true);
                setTimeout(() => {
                    navigate('/signup');
                }, 2000);
            } else if(response.flag === 200) {
                // Sort data in descending order by truck_head_id before setting it
                const sortedData = [...response.data].sort((a, b) => {
                    if (a[orderBy] < b[orderBy]) return order === 'asc' ? -1 : 1;
                    if (a[orderBy] > b[orderBy]) return order === 'asc' ? 1 : -1;
                    return 0;
                });
                setRows(sortedData);
                
                // Format data for CSV export
                const formattedData = formatDataForCSV(sortedData);
                setAllData(formattedData);
            }
        }
        catch (error) {
            console.log('error', error);
        }
    }

    useEffect(()=> {
        fetchTruckHeadData();
        fetchVendorsData();
    },[cityFilter])

    const handleSubmit = async() =>{
        // Validate all required fields
        const errors = {
            plateNo: !plateNo.trim(),
            type: !type,
            truckerId: !truckerId,
            availabilityStatus: !availabilityStatus,
            remarks: !remarks.trim()
        };
        
        // Update error state
        setFormErrors(errors);
        
        // Check if any validation errors exist
        if (Object.values(errors).some(error => error)) {
            setMessage('Please fill in all required fields correctly');
            showSnackbar(true);
            return; // Prevent form submission
        }
        
        const token = localStorage.getItem('token');
        const payload = {
            token: token,
            city_id: cityFilter,
            truck_plate_no: plateNo,
            type: type,
            availability_status: availabilityStatus,
            remarks: remarks,
            // availability_time: availabilityTime,
            truck_vendor_id: truckerId
        };
        if(editable && truckHeadId!=''){
            payload.truck_head_id = truckHeadId;
        }

        try {
            const url = operationsUrl + '/transport/add_update_truck_heads';
            const response = await makePostRequestToUrl(url,payload);
            if (response.flag === 200) {
                setMessage(response.message)
                showSnackbar(true);
                handleClose();
                fetchTruckHeadData();
            } else {
                setMessage(response.message)
                showSnackbar(true);
            }

        } catch (error) {
            console.error('Error while saving document:', error);
            setMessage(error);
        }

    }

    const handleOpenEditTruckHead = (row) => {
        setOpen(true);
        setEditable(true);
        setPlateNo(row.truck_plate_no);
        setTruckHeadId(row.truck_head_id);
        setType(row.type);
        setAvailabilityStatus(row.availability_status);
        setRemarks(row.remarks);
        setTruckerId(row.truck_vendor_id);
        // setAvailabilityTime(dayjs(row.availability_time));
        setFormErrors({
            plateNo: false,
            type: false,
            truckerId: false,
            availabilityStatus: false,
            remarks: false
        });
    }

    const handleSnackbarClose = (event, reason) => {
        if (reason === 'clickaway') {
            return;
        }
        showSnackbar(false);
        setShowTemplateButton(false);
    };
    
    // Define required columns for CSV import
    const requiredColumns = ['truck_plate_no', 'type', 'availability_status', 'remarks', 'truck_vendor_id'];
    
    const alternativeColumns = {
        'truck_plate_no': ['Plate Number', 'truck_plate_no', 'TRUCK_PLATE_NO', 'Plate_Number'],
        'type': ['Type', 'type', 'TYPE'],
        'availability_status': ['Availability Status', 'availability_status', 'AVAILABILITY_STATUS', 'Status'],
        'remarks': ['Remarks', 'remarks', 'REMARKS'],
        'truck_vendor_id': ['Truck Vendor ID', 'truck_vendor_id', 'TRUCK_VENDOR_ID', 'Vendor ID']
    };

    // Format data for CSV export
    const formatDataForCSV = (data) => {
        return data ? (data.map(item => ({
            "Truck Head ID": item.truck_head_id,
            "Plate Number": item.truck_plate_no,
            "Type": item.type ==1 ? 'Franchise' : item.type ==2 ? 'Spot Hire': 'Unknown',
            "Availability Status": item.availability_status==1 ? 'Inspection' : item.availability_status==2 ? 'Available' : item.availability_status==3 ? 'Absent' : item.availability_status==4 ? 'Repair' : item.availability_status==5 ? 'Break' : item.availability_status==6 ? 'Off' : 'Unknown',
            "Truck Vendor": item.truck_vendor_id,
            "Remarks": item.remarks
        }))) : [];
    };
    
    // Function to download template CSV file
    const downloadCSVTemplate = () => {
        // Use the required columns with example data
        const headers = requiredColumns.map(col => alternativeColumns[col] ? alternativeColumns[col][0] : col);
        const exampleRow = ['ABC123', 'Container', 'Inspection', 'Good condition', '1'];
        const csvContent = headers.join(',') + '\n' + exampleRow.join(',');

        // Create a blob and download
        const blob = new Blob([csvContent], { type: 'text/csv;charset=utf-8;' });
        const url = URL.createObjectURL(blob);
        const link = document.createElement('a');
        link.href = url;
        link.setAttribute('download', 'TruckHeads_Template.csv');
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
    };
    
    // Function to handle import CSV button click
    const handleImportCSV = () => {
        if (fileInputRef.current) {
            fileInputRef.current.click();
        }
    };
    
    // Function to handle file selection
    const handleFileSelect = (event) => {
        const file = event.target.files[0];
        if (!file) {
            setMessage('No file selected');
            showSnackbar(true);
            return;
        }
        
        const token = localStorage.getItem('token');
        
        // Use handleImportCSVWithCaseInsensitive with proper callbacks
        handleImportCSVWithCaseInsensitive(
            file,
            // onSuccess callback
            async (data) => {
                try {
                    const apiData = data.map(row => ({
                        city_id: cityFilter,
                        truck_plate_no: row.truck_plate_no,
                        type: row.type,
                        availability_status: row.availability_status,
                        remarks: row.remarks,
                        truck_vendor_id: row.truck_vendor_id
                    }));
                    
                    const url = operationsUrl + '/transport/add_bulk_truck_heads';
                    const requestData = {
                        token: token,
                        truck_heads: apiData
                    };
                    
                    const response = await makePostRequestToUrl(url, requestData);
                    
                    if (response.flag === 200) {
                        setMessage('CSV import successful!');
                        showSnackbar(true);
                        fetchTruckHeadData();
                    } else if (response.flag === 401 || response.flag === 102) {
                        setTokenExpired(true);
                        setMessage('Your session has expired. Please log in again.');
                        showSnackbar(true);
                        setTimeout(() => {
                            navigate('/signup');
                        }, 2000);
                    } else {
                        setMessage(response.message || 'Error importing CSV');
                        showSnackbar(true);
                    }
                } catch (error) {
                    console.error('Error processing import:', error);
                    setMessage('Error processing import. Please check the CSV format.');
                    setShowTemplateButton(true);
                    showSnackbar(true);
                }
                
                // Reset the file input
                event.target.value = '';
            },
            // onError callback
            (error) => {
                console.error('CSV parsing error:', error);
                let errorMessage = 'Error parsing CSV file';
                
                if (error.requiredColumns) {
                    errorMessage = `Missing required columns: ${error.requiredColumns.join(', ')}`;
                    setShowTemplateButton(true);
                } else if (typeof error === 'string') {
                    errorMessage = error;
                } else if (error.message) {
                    errorMessage = error.message;
                }
                
                setMessage(errorMessage);
                setShowTemplateButton(true);
                showSnackbar(true);
                event.target.value = '';
            },
            requiredColumns,
            alternativeColumns
        );
    };

    // Generate template data for CSV download
    const generateTemplateData = () => {
        // Create header row using the first alternative column name for each required column
        const headers = requiredColumns.map(col => alternativeColumns[col] ? alternativeColumns[col][0] : col);

        // Create an empty row example
        const emptyRow = {};
        requiredColumns.forEach(col => {
            emptyRow[alternativeColumns[col] ? alternativeColumns[col][0] : col] = '';
        });

        return [headers.reduce((obj, header, index) => {
            obj[header] = '';
            return obj;
        }, {})];
    };

    // Template CSV headers for download
    const templateHeaders = requiredColumns.map(col => ({
        label: alternativeColumns[col] ? alternativeColumns[col][0] : col,
        key: alternativeColumns[col] ? alternativeColumns[col][0] : col
    }));

    // Function to display a custom action in the Snackbar for download template
    const SnackbarAction = () => {
        if (showTemplateButton) {
            return (
                <Button 
                    color="primary" 
                    size="small" 
                    onClick={downloadCSVTemplate}
                    style={{ backgroundColor: '#0065FF', color: 'white', marginLeft: '10px' }}
                >
                    Download Template
                </Button>
            );
        }
        return null;
    };

    // Update the Snackbar component to show the download template button when needed
    const snackbarAction = showTemplateButton ? (
        <Button 
            color="primary" 
            size="small" 
            onClick={downloadCSVTemplate}
            style={{ backgroundColor: '#0065FF', color: 'white', marginLeft: '10px' }}
        >
            Download Template
        </Button>
    ) : null;

    // Process imported truck head data using the shared processBulkImport function
    const processTruckHeadImport = async (data) => {
        const token = localStorage.getItem('token');
        const url = operationsUrl + '/transport/add_bulk_truck_heads';

        // Map function to convert CSV data to the expected API format
        const mapTruckHeadData = (item) => {
            // Create truck head data object
            const truckHeadData = {
                truck_plate_no: item.truck_plate_no,
                type: item.type ==1 ? 'Franchise' : item.type ==2 ? 'Spot Hire': 'Unknown',
                availability_status: item.availability_status==1 ? 'Inspection' : item.availability_status==2 ? 'Available' : item.availability_status==3 ? 'Absent' : item.availability_status==4 ? 'Repair' : item.availability_status==5 ? 'Break' : item.availability_status==6 ? 'Off' : 'Unknown',
                remarks: item.remarks,
                truck_vendor_id: item.truck_vendor_id,
                city_id: cityFilter
            };

            return truckHeadData;
        };

        // Use the shared processBulkImport function
        return await processBulkImport(data, token, url, 'truck_heads', mapTruckHeadData);
    };

    return(
        <div>
            {tokenExpired && (<TokenError/>)}

            <Typography style={{ fontSize: '28px', fontWeight: '500' }}>
                Truck Head
            </Typography>

            <Grid2 container spacing={2} alignItems="center" style={{ marginTop: '2%', marginBottom: '3%' }}>
                <Grid2 item>
                <Select value={cityFilter} 
                    onChange={(e) => handleCityChange(e.target.value)} displayEmpty
                    style={{width: '190px',height:'50px',borderRadius:'8px',backgroundColor: cityFilter ? '#F9F9F9' : '#FFFFFF'}}>
                        <MenuItem value="">Select City</MenuItem>
                        {cities.map((city) => (
                            <MenuItem key={city.city_name} value={city.city_id}>
                                {city.city_name}
                            </MenuItem>
                        ))}
                    </Select>
                </Grid2>
                <Grid2 item>
                    <Button
                        variant="contained"
                        onClick={handleOpenAddTruckHead}
                        style={{
                            width: '185px',
                            height: '50px',
                            backgroundColor: '#000000',
                            textTransform: 'none',
                            borderRadius: '8px',
                        }}
                    >
                        + Add Truck Head
                    </Button>
                </Grid2>
                <Grid2 sx={{marginLeft: "auto", display: 'flex', alignItems: 'center', gap: 2}}>
                    
                    
                    {/* Hidden file input for CSV import */}
                    <input
                        type="file"
                        accept=".csv"
                        ref={fileInputRef}
                        style={{ display: 'none' }}
                        onChange={handleFileSelect}
                    />
                    
                    {/* Sample CSV Button */}
                    <Button
                        variant="outlined"
                        onClick={downloadCSVTemplate}
                        style={{
                            display: 'flex',
                            alignItems: 'center',
                            justifyContent: 'center',
                            border: '1.5px solid #000',
                            background: '#fff',
                            color: '#000',
                            borderRadius: '8px',
                            minWidth: '120px',
                            height: '44px',
                            fontWeight: 500,
                            fontSize: '16px',
                            textTransform: 'none',
                            boxShadow: 'none'
                        }}
                    >
                        <img src={importArrowIcon} alt="Sample CSV" style={{ width: 20, height: 20, marginRight: 8, marginTop: 2 }} />
                        <span style={{ fontWeight: 500, fontSize: 16 }}>Sample CSV</span>
                    </Button>
                    
                    {/* Import CSV Button */}
                    <Button
                        variant="outlined"
                        onClick={handleImportCSV}
                        style={{
                            display: 'flex',
                            alignItems: 'center',
                            justifyContent: 'center',
                            border: '1.5px solid #000',
                            background: '#fff',
                            color: '#000',
                            borderRadius: '8px',
                            minWidth: '120px',
                            height: '44px',
                            fontWeight: 500,
                            fontSize: '16px',
                            textTransform: 'none',
                            boxShadow: 'none'
                        }}
                    >
                        <img src={importArrowIcon} alt="Import CSV" style={{ width: 20, height: 20, marginRight: 8, marginTop: 2 }} />
                        <span style={{ fontWeight: 500, fontSize: 16 }}>Import CSV</span>
                    </Button>

                    {/* Export CSV Button */}
                    <Button
                        variant="outlined"
                        style={{
                            display: 'flex',
                            alignItems: 'center',
                            justifyContent: 'center',
                            border: '1.5px solid #000',
                            background: '#fff',
                            color: '#000',
                            borderRadius: '8px',
                            minWidth: '120px',
                            height: '44px',
                            fontWeight: 500,
                            fontSize: '16px',
                            textTransform: 'none',
                            boxShadow: 'none'
                        }}
                    >
                        <CSVLink
                            data={allData}
                            filename={"Truck_Heads.csv"}
                            style={{
                                display: 'flex',
                                alignItems: 'center',
                                gap: 10,
                                textDecoration: 'none',
                                color: 'inherit',
                                width: '100%',
                                justifyContent: 'center',
                            }}
                        >
                            <span style={{ fontWeight: 500, fontSize: 16 }}>Export CSV</span>
                            <img src={exportCSVIcon} alt="Export CSV" style={{ width: 18, height: 18, marginLeft: 4, marginTop: 2 }} />
                        </CSVLink>
                    </Button>
                </Grid2>
            </Grid2>

            {open && (
                <div 
                    style={{position: 'fixed',top: 65, right:0, height: '100%',width: '50%',backgroundColor: '#f9f9f9',
                        boxShadow: '0px 0px 10px rgba(0, 0, 0, 0.1)',transition: 'right 0.3s ease-in-out',
                        zIndex: 1000,overflowY: 'auto',padding: 20
                    }}>
                    <Box>
                        <div style={{ position: 'relative', padding: '40px 0' }}>
                            <IconButton aria-label="close" onClick={handleClose}
                                style={{
                                    position: 'absolute',top: '-15px',left: '1px',color: '#333',zIndex: 10}}>
                                <CloseIcon style={{ fontSize: '32px', fontWeight: 'bold' }} />
                            </IconButton>
                            <Paper elevation={3}
                                style={{ padding: '30px', maxWidth: '800px', margin: '0 auto',
                                    backgroundColor: '#FFFFFF', borderRadius: '12px'}}>
                                <Typography variant="h6" style={{ marginBottom: '20px', marginTop: '20px', fontWeight: 'bold' }}>
                                    {editable ? 'Edit Truck Head' : 'Add Truck Head'}
                                </Typography>

                                <Grid container spacing={2}>
                                    
                                    <Grid item xs={12} sm={6}>
                                        <Label style={{color:'#1A1E25', fontSize:'16px'}}>Plate Number<span style={{ color: 'red' }}>*</span></Label>
                                        {formErrors.plateNo && <Typography sx={{ color: '#d32f2f', fontSize: '0.75rem', mt: 0.5 }}>Plate Number is required</Typography>}
                                        <TextField sx={{marginTop:'1%'}} placeholder="Plate Number" fullWidth variant="outlined" type="text"
                                            value={plateNo} 
                                            onChange={(e) => {
                                                setPlateNo(e.target.value);
                                                setFormErrors({...formErrors, plateNo: !e.target.value.trim()});
                                            }}
                                            error={formErrors.plateNo}
                                            InputProps={{
                                                inputProps: { min: 0 }, // Prevent values less than zero
                                                style: {
                                                    height: '52px',
                                                    borderRadius:'12px',
                                                    fontSize: '16px',
                                                    padding: '8px 14px',
                                                    backgroundColor: '#FFFFFF',
                                                },
                                            }}
                                        />
                                    </Grid>

                                    <Grid item xs={12} sm={6}>
                                        <Label style={{color:'#1A1E25', fontSize:'16px'}}>Truck Vendor ID<span style={{ color: 'red' }}>*</span></Label>
                                        {formErrors.truckerId && <Typography sx={{ color: '#d32f2f', fontSize: '0.75rem', mt: 0.5 }}>Truck Vendor Id is required</Typography>}
                                        <Select sx={{marginTop:'2%'}}
                                            value={truckerId} 
                                            fullWidth
                                            onChange={(e) => {
                                                setTruckerId(e.target.value);
                                                setFormErrors({...formErrors, truckerId: !e.target.value});
                                            }}
                                            error={formErrors.truckerId}
                                            style={{ height: '50px', borderRadius: '8px', backgroundColor: '#FFFFFF',
                                                   border: formErrors.truckerId ? '1px solid #d32f2f' : 'none' }}>
                                            {truckVendorData && truckVendorData.map((truckVendor) => (
                                                <MenuItem key={truckVendor.truck_vendor_id} value={truckVendor.truck_vendor_id}>
                                                    {truckVendor.name}
                                                </MenuItem>
                                            ))}
                                        </Select>
                                    </Grid>

                                </Grid>

                                <Grid2 sx={{border: formErrors.type ? '1px solid #d32f2f' : '1px solid #D1D5DB', borderRadius:'12px', padding:'8px', marginTop:'16px'}}>
                                    <Grid2 sx={{fontSize:'16px', fontWeight:'500', backgroundColor:'#F9F9F9', padding:'8px 14px', borderRadius:'8px'}}>
                                        Type<span style={{ color: 'red' }}>*</span>
                                    </Grid2>
                                    {formErrors.type && <Typography sx={{ color: '#d32f2f', fontSize: '0.75rem', mt: 0.5, ml: 2 }}>Type is required</Typography>}
                                    <Grid2 container spacing={2} sx={{justifyContent:'space-between', marginTop:'2%', px: 2, py: 3}}>
                                        <FormControl component="fieldset">
                                            <RadioGroup
                                                row
                                                aria-label="contract-type"
                                                name="contract-type"
                                                value={type}
                                                onChange={(e) => {
                                                    setType(e.target.value);
                                                    setFormErrors({...formErrors, type: !e.target.value});
                                                }}
                                                sx={{
                                                    width: '100%',
                                                    display: 'flex',
                                                    justifyContent: 'space-between',
                                                    gap: '30px',
                                                    '& .MuiFormControlLabel-root': {
                                                        flex: 1,
                                                        margin: 0,
                                                        minWidth: '40%',
                                                    }
                                                }}
                                            >
                                                <FormControlLabel
                                                    value="1" 
                                                    control={
                                                        <Radio sx={{'&.Mui-checked': {color: '#6B7280' }}}/>
                                                    } 
                                                    label={
                                                        <Typography sx={{ color: '#6B7280', fontSize: '16px' }}>
                                                            Lease
                                                        </Typography>
                                                    }
                                                />
                                                <FormControlLabel 
                                                    value="2" 
                                                    control={
                                                        <Radio sx={{'&.Mui-checked': {color: '#6B7280'}}}/>
                                                    } 
                                                    label={
                                                        <Typography sx={{ color: '#6B7280', fontSize: '16px' }}>
                                                            Spot Hire
                                                        </Typography>
                                                    }
                                                />
                                            </RadioGroup>
                                        </FormControl>
                                    </Grid2>
                                </Grid2>

                                <Grid item xs={12} sm={12} sx={{marginTop:'2%'}}>
                                    <Label>Truck Availability Status<span style={{ color: 'red' }}>*</span></Label>
                                    {formErrors.availabilityStatus && <Typography sx={{ color: '#d32f2f', fontSize: '0.75rem', mt: 0.5 }}>Availability Status is required</Typography>}
                                    <Select sx={{marginTop:'1%'}}
                                        value={availabilityStatus} 
                                        fullWidth
                                        onChange={(e) => {
                                            setAvailabilityStatus(e.target.value);
                                            setFormErrors({...formErrors, availabilityStatus: !e.target.value});
                                        }}
                                        error={formErrors.availabilityStatus}
                                        style={{ height: '50px', borderRadius: '8px', backgroundColor: '#FFFFFF',
                                               border: formErrors.availabilityStatus ? '1px solid #d32f2f' : 'none' }}>
                                        
                                            {Object.entries(constants.truckHeadAvailabilityStatus).map(([id, label]) => (
                                                <MenuItem key={id} value={id}>
                                                    {label}
                                                </MenuItem>
                                            ))}
                                    </Select>
                                </Grid>
                                {/* <Grid item xs={12} sm={12} sx={{marginTop:'2%'}}>
                                    <Label>Truck Availability Date<span style={{ color: 'red' }}>*</span></Label>
                                    <LocalizationProvider dateAdapter={AdapterDayjs}>
                                        <DemoContainer components={['DatePicker']}>
                                            <DatePicker sx={{height:'50px'}}
                                            value={availabilityTime}
                                            onChange={(newValue) => setAvailabilityTime(newValue)}
                                            />
                                        </DemoContainer>
                                    </LocalizationProvider>
                                </Grid> */}

                                <Grid item xs={12} sm={12} sx={{marginTop:'2%'}}>
                                    <Label>Remarks<span style={{ color: 'red' }}>*</span></Label>
                                    {formErrors.remarks && <Typography sx={{ color: '#d32f2f', fontSize: '0.75rem', mt: 0.5 }}>Remarks are required</Typography>}
                                    <TextField
                                        sx={{ marginTop: '1%' }}
                                        placeholder="Enter remarks here"
                                        fullWidth
                                        variant="outlined"
                                        multiline
                                        error={formErrors.remarks}
                                        value={remarks}
                                        onChange={(e) => {
                                            setRemarks(e.target.value);
                                            setFormErrors({...formErrors, remarks: !e.target.value.trim()});
                                        }}
                                        rows={3}
                                        InputProps={{
                                            style: {
                                                fontSize: '16px',
                                                padding: '8px 14px',
                                                backgroundColor: '#FFFFFF',
                                                borderRadius: '8px',
                                            },
                                        }}
                                    />
                                </Grid>

                                <div style={{ marginTop: '40px', display: 'flex', justifyContent: 'center', gap: '20px' }}>
                                    <Button
                                        variant="contained"
                                        color="primary"
                                        onClick={handleSubmit}
                                        sx={{width: '140px',height: '50px',textTransform: 'none',
                                            fontSize: '16px',backgroundColor: '#0065FF',color: 'white'}}>
                                        {editable ? 'Update' : 'Save'}
                                    </Button>
                                    <Button
                                        variant="contained"
                                        onClick={handleClose}
                                        sx={{
                                            width: '140px',
                                            height: '50px',
                                            textTransform: 'none',
                                            fontSize: '16px',
                                            backgroundColor: '#F0F0F0',
                                            color: '#B0B0B0',
                                        }}
                                    >
                                        Cancel
                                    </Button>
                                </div>
                            </Paper>

                        </div>
                    </Box>
                </div>
            )}

            <TableContainer className="table-container">
                <Table stickyHeader className="scrollable-table">
                    <TableHead>
                        <TableRow>
                            <TableCell align="center" className="table-header">
                                <TableSortLabel
                                    active={orderBy === 'truck_head_id'}
                                    direction={orderBy === 'truck_head_id' ? order : 'asc'}
                                    onClick={() => handleRequestSort('truck_head_id')}
                                >
                                    Truck Head ID
                                </TableSortLabel>
                            </TableCell>
                            <TableCell align="center" className="table-header">
                                <TableSortLabel
                                    active={orderBy === 'truck_plate_no'}
                                    direction={orderBy === 'truck_plate_no' ? order : 'asc'}
                                    onClick={() => handleRequestSort('truck_plate_no')}
                                >
                                    Plate No
                                </TableSortLabel>
                            </TableCell>
                            <TableCell align="center" className="table-header">
                                <TableSortLabel
                                    active={orderBy === 'type'}
                                    direction={orderBy === 'type' ? order : 'asc'}
                                    onClick={() => handleRequestSort('type')}
                                >
                                    Type
                                </TableSortLabel>
                            </TableCell>
                            <TableCell align="center" className="table-header">
                                <TableSortLabel
                                    active={orderBy === 'availability_status'}
                                    direction={orderBy === 'availability_status' ? order : 'asc'}
                                    onClick={() => handleRequestSort('availability_status')}
                                >
                                    Availability Status
                                </TableSortLabel>
                            </TableCell>
                            <TableCell align="center" className="table-header">
                                <TableSortLabel
                                    active={orderBy === 'name'}
                                    direction={orderBy === 'name' ? order : 'asc'}
                                    onClick={() => handleRequestSort('name')}
                                >
                                    Truck Vendor ID
                                </TableSortLabel>
                            </TableCell>
                            <TableCell align="center" className="table-header">
                                <TableSortLabel
                                    active={orderBy === 'remarks'}
                                    direction={orderBy === 'remarks' ? order : 'asc'}
                                    onClick={() => handleRequestSort('remarks')}
                                >
                                    Remarks
                                </TableSortLabel>
                            </TableCell>
                            <TableCell align="center" className="table-header">Actions</TableCell>
                        </TableRow>
                    </TableHead>
                    <TableBody>
                        {rows.length === 0 && (
                            <TableRow>
                                <TableCell colSpan={6} align="center">
                                    <Typography variant="body1">No data found</Typography>
                                </TableCell>
                            </TableRow>
                        )}
                        {(rowsPerPage > 0
                            ? rows.slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage)
                            : rows
                        ).map((row) => (
                            <TableRow key={row.truck_head_id}>
                                <TableCell>{row.truck_head_id}</TableCell>
                                <TableCell>{row.truck_plate_no}</TableCell>
                                <TableCell>{row.type ==1 ? 'Franchise' : row.type ==2 ? 'Spot Hire': 'Unknown'}</TableCell>
                                <TableCell>{row.availability_status==1 ? 'Inspection' : row.availability_status==2 ? 'Available' : row.availability_status==3 ? 'Absent' : row.availability_status==4 ? 'Repair' : row.availability_status==5 ? 'Break' : row.availability_status==6 ? 'Off' : 'Unknown'}</TableCell>
                                <TableCell>{row.name}</TableCell>
                                <TableCell>{row.remarks}</TableCell>
                                <TableCell>
                                    <Button
                                        variant="contained"
                                        onClick={() => handleOpenEditTruckHead(row)}
                                        sx={{
                                            backgroundColor: '#EFFBF7', color: '#0DBA78', border: '1px solid #0DBA78', textTransform: 'none',
                                            borderRadius: '8px', minWidth:'40px', boxShadow:'none', width:"90px",
                                            '&:hover': {backgroundColor: '#0DBA78', color: 'white'},
                                            '&:active': { backgroundColor: '#0DBA78', color: 'white'}
                                        }}>
                                        
                                        <Typography sx={{marginRight:'6%'}}>Edit</Typography>
                                    </Button>

                                    {/* <IconButton 
                                        aria-label="more options" 
                                        size="small"
                                        onClick={(e) => handleMenuOpen(e, row)}
                                        sx={{ marginLeft: '4px' }}
                                    >
                                        <img src={threeDots} alt="threeDots"/>
                                    </IconButton>
                                    
                                    <Menu
                                        anchorEl={menuAnchorEl}
                                        open={Boolean(menuAnchorEl) && selectedRow?.truck_vendor_id === row.truck_vendor_id}
                                        onClose={handleMenuClose}
                                        PaperProps={{
                                            elevation: 3,
                                            sx: {
                                                borderRadius: '8px',
                                                minWidth: '160px',
                                                padding: '4px 0',
                                                overflow: 'visible',
                                                '&:before': {
                                                    content: '""',
                                                    display: 'block',
                                                    position: 'absolute',
                                                    top: 0,
                                                    right: 14,
                                                    width: 10,
                                                    height: 10,
                                                    bgcolor: 'background.paper',
                                                    transform: 'translateY(-50%) rotate(45deg)',
                                                    zIndex: 0,
                                                },
                                            },
                                        }}
                                        transformOrigin={{ horizontal: 'right', vertical: 'top' }}
                                        anchorOrigin={{ horizontal: 'right', vertical: 'bottom' }}
                                    >
                                        <MenuItem onClick={() => openConfirmDialog(row.status === 2 ? 'unblock' : 'block', row)} sx={{ py: 1 }}>
                                            <ListItemText primary={row.status === 2 ? "Unblock" : "Block"} sx={{ color: '#6B7280' }} />
                                            <ListItemIcon>
                                                <img src={BlockImg} alt="block"/>
                                            </ListItemIcon>
                                        </MenuItem>
                                        <MenuItem onClick={() => openConfirmDialog('delete', row)} sx={{ py: 1 }}>
                                            <ListItemText primary="Delete" sx={{ color: '#6B7280' }} />
                                            <ListItemIcon>
                                                <img src={deleteImg} alt="delete"/>
                                            </ListItemIcon>
                                        </MenuItem>
                                    </Menu> */}
                                </TableCell>
                            </TableRow>
                        ))}
                    </TableBody>
                </Table>
                <div className="custom-pagination">
                    <div className="pagination-info">
                        {`Showing ${page * rowsPerPage + 1} to ${Math.min(
                            (page + 1) * rowsPerPage,
                            rows.length
                        )} of ${rows.length} entries`}
                    </div>
                    <div className="pagination-controls">
                        <button
                            onClick={() => handleChangePage(null, page - 1)}
                            disabled={page === 0}
                            className="pagination-arrow"
                        >
                            <img src={prevIcon} alt="Previous" />
                        </button>
                        <div className="pagination-numbers">
                            {[...Array(Math.ceil(rows.length / rowsPerPage))].map((_, index) => (
                                <button key={index} onClick={() => handleChangePage(null, index)}
                                    className={`pagination-number ${page === index ? 'active' : ''}`}>
                                    {index + 1}
                                </button>
                            ))}
                        </div>
                        <button
                            onClick={() => handleChangePage(null, page + 1)}
                            disabled={page >= Math.ceil(rows.length / rowsPerPage) - 1}
                            className="pagination-arrow"
                        >
                            <img src={nextIcon} alt="Next" />
                        </button>
                    </div>
                </div>
            </TableContainer>

            <Snackbar 
                open={snackbar} 
                autoHideDuration={6000} 
                onClose={handleSnackbarClose} 
                message={message}
                action={snackbarAction}
            />
        </div>
    )
}

export default TruckHead;